module.exports = __webpack_public_path__ + "static/antd-datepicker-select-range-472e859d8ca7ac80096b95240beaf840.png";